import { render, staticRenderFns } from "./annoucement.vue?vue&type=template&id=7aaff111&"
import script from "./annoucement.vue?vue&type=script&lang=js&"
export * from "./annoucement.vue?vue&type=script&lang=js&"
import style0 from "./annoucement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports